/**
 * Geometry utilities - Sprint X Phase X1
 */

export const SUPPORTED_EXTENSIONS = ['.kml', '.kmz', '.geojson', '.json', '.gpx', '.csv'];

// One geometry import limit for every tariff (mission-map plan PR4/PR6, = QuotaService.MaxSingleFileBytes
// on the server). Only a fallback - the dialog uses max_import_file_bytes from
// GET /missions/flight-area/settings, and the server enforces its own limit regardless.
export const MAX_GEOMETRY_FILE_BYTES = 50 * 1024 * 1024;

/** Client-side pre-check of a picked file. `error` is 'no_file' | 'unsupported' | 'too_large'. */
export const validateGeometryFile = (file, maxBytes = MAX_GEOMETRY_FILE_BYTES) => {
  if (!file) return { valid: false, error: 'no_file' };

  const fileName = file.name.toLowerCase();
  const hasValidExtension = SUPPORTED_EXTENSIONS.some(ext => fileName.endsWith(ext));

  if (!hasValidExtension) {
    return { valid: false, error: 'unsupported' };
  }

  if (file.size > maxBytes) {
    return { valid: false, error: 'too_large' };
  }

  return { valid: true };
};

export const detectFormat = (filename) => {
  const lower = filename.toLowerCase();
  if (lower.endsWith('.kml')) return 'kml';
  if (lower.endsWith('.kmz')) return 'kmz';
  if (lower.endsWith('.geojson') || lower.endsWith('.json')) return 'geojson';
  if (lower.endsWith('.gpx')) return 'gpx';
  if (lower.endsWith('.csv')) return 'csv';
  return 'unknown';
};

export const formatBytes = (bytes) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
